import React from 'react';
import ContentPage from './ContentPage';
import { pageContent } from '../utils/contentUtils';

const PrivacyPolicyPage: React.FC = () => {
  const { title, description, fileName } = pageContent.privacyPolicy;
  
  return (
    <ContentPage
      title={title}
      description={description}
      fileName={fileName}
      showCallToAction={false}
    />
  );
};

export default PrivacyPolicyPage;
